
export enum EScreenFieldNames {
  "Screen"="screen",
}
export interface IScreen {
    [EScreenFieldNames.Screen]?: boolean | any;
}
